import React, { useState, useEffect } from 'react';
import './NewProduct.css'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
export default function NewProduct({ productosCantidadAhora = 0, productosCantidadMaxima = 0 }) {
    const WEEKDAYS = ["lunes", "martes", "miercoles", "jueves", "viernes", "sabado", "domingo"];
    const [demora, setDemora] = useState({}); // minutos
    const [dias, setDias] = useState({});
    const [profesionales, setProfesionales] = useState([]);

    /**
     * Función auxiliar para calcular el array de turnos como objetos.
     * Retorna: [{ hora: "08:00", activo: true }, ...]
     */
    const calcularArrayTurnos = (inicio, fin, tiempoDemora) => {
      if (!inicio || !fin || !tiempoDemora) return [];
      const turnos = [];
      let [hi, mi] = inicio.split(":").map(Number);
      let [hf, mf] = fin.split(":").map(Number);

      let actual = hi * 60 + mi;
      const finMin = hf * 60 + mf;
      const d = Number(tiempoDemora);

      while (actual + d <= finMin) {
        const h = String(Math.floor(actual / 60)).padStart(2, "0");
        const m = String(actual % 60).padStart(2, "0");
        // Se guardan como objetos para poder "apagarlos" individualmente
        turnos.push({ hora: `${h}:${m}`, activo: true });
        actual += d;
      }
      return turnos;
    };

    const toggleDia = (profId, dia) => {
      setDias((prev) => {
        const profConfig = prev[profId] || {};
        if (profConfig[dia]) {
          const newProfConfig = { ...profConfig };
          delete newProfConfig[dia];
          return { ...prev, [profId]: newProfConfig };
        } else {
          const inicioDef = "08:00";
          const finDef = "17:00";
          const tiempo = demora[profId] || 30;
          return {
            ...prev,
            [profId]: {
              ...profConfig,
              [dia]: {
                inicio: inicioDef,
                fin: finDef,
                turnos: calcularArrayTurnos(inicioDef, finDef, tiempo),
              },
            },
          };
        }
      });
    };

    const cambiarHora = (profId, dia, campo, valor) => {
      setDias((prev) => {
        const configActual = prev[profId][dia];
        const nuevaConfigDia = { ...configActual, [campo]: valor };

        // Recalcular turnos automáticamente al cambiar hora de inicio o fin
        nuevaConfigDia.turnos = calcularArrayTurnos(
          campo === "inicio" ? valor : nuevaConfigDia.inicio,
          campo === "fin" ? valor : nuevaConfigDia.fin,
          demora[profId] || 30
        );

        return {
          ...prev,
          [profId]: { ...prev[profId], [dia]: nuevaConfigDia },
        };
      });
    };

    // Nueva función para habilitar/deshabilitar un turno específico (ej: almuerzo)
    const toggleTurnoEspecifico = (profId, dia, horaPresionada) => {
      setDias((prev) => {
        const turnosActualizados = prev[profId][dia].turnos.map((t) =>
          t.hora === horaPresionada ? { ...t, activo: !t.activo } : t
        );

        return {
          ...prev,
          [profId]: {
            ...prev[profId],
            [dia]: { ...prev[profId][dia], turnos: turnosActualizados },
          },
        };
      });
    };

    // Función para cuando cambias la duración (demora) de un profesional
    const cambiarDemoraProfesional = (profId, nuevoValor) => {
      const tiempo = Number(nuevoValor);
      setDemora((prev) => ({ ...prev, [profId]: tiempo }));

      setDias((prev) => {
        const profConfig = prev[profId];
        if (!profConfig) return prev;

        const nuevaConfigConNuevosTurnos = {};
        Object.keys(profConfig).forEach((dia) => {
          nuevaConfigConNuevosTurnos[dia] = {
            ...profConfig[dia],
            turnos: calcularArrayTurnos(profConfig[dia].inicio, profConfig[dia].fin, tiempo),
          };
        });

        return { ...prev, [profId]: nuevaConfigConNuevosTurnos };
      });
    };


    const [rules, setRules] = useState([]);
    const [newRuleType, setNewRuleType] = useState("weekday");
    const [newRuleValue, setNewRuleValue] = useState("");

    const [mensaje, setMensaje] = useState('');
    const [categoriaEsServicio, setCategoriaEsServicio] = useState(false);

    const [imagenPreview1, setImagenPreview1] = useState(null);
    const [imagenPreview2, setImagenPreview2] = useState(null);
    const [imagenPreview3, setImagenPreview3] = useState(null);
    const [imagenPreview4, setImagenPreview4] = useState(null);
    const [imagenPreview5, setImagenPreview5] = useState(null);
    const [imagenPreview6, setImagenPreview6] = useState(null);
    const [imagenPreview7, setImagenPreview7] = useState(null);
    const [imagenPreview8, setImagenPreview8] = useState(null);
    const [imagenPreview9, setImagenPreview9] = useState(null);
    const [imagenPreview10, setImagenPreview10] = useState(null);
    const [imagenPreview11, setImagenPreview11] = useState(null);
    const [imagenPreview12, setImagenPreview12] = useState(null);

    const [descripcion, setDescripcion] = useState('');
    const [titulo, setTitulo] = useState('');
    const [categoria, setCategoria] = useState('');
    const [masVendido, setMasVendido] = useState('');
    const [precio, setPrecio] = useState('');
    const [isImage1Selected, setIsImage1Selected] = useState(false);
    const [isImage2Selected, setIsImage2Selected] = useState(false);
    const [isImage3Selected, setIsImage3Selected] = useState(false);
    const [isImage4Selected, setIsImage4Selected] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [categorias, setCategoras] = useState([]);
    const [item1, setItem1] = useState('');
    const [item2, setItem2] = useState('');
    const [item3, setItem3] = useState('');
    const [item4, setItem4] = useState('');
    const [item5, setItem5] = useState('');
    const [item6, setItem6] = useState('');
    const [item7, setItem7] = useState('');
    const [item8, setItem8] = useState('');
    const [item9, setItem9] = useState('');
    const [item10, setItem10] = useState('');
    const [precio1, setPrecio1] = useState('');
    const [precio2, setPrecio2] = useState('');
    const [precio3, setPrecio3] = useState('');
    const [precio4, setPrecio4] = useState('');
    const [precio5, setPrecio5] = useState('');
    const [precio6, setPrecio6] = useState('');
    const [precio7, setPrecio7] = useState('');
    const [precio8, setPrecio8] = useState('');
    const [precio9, setPrecio9] = useState('');
    const [precio10, setPrecio10] = useState('');
    const [precioAnterior, setPrecioAnterior] = useState('');
    const [stock, setStock] = useState('');
    const toggleModal = () => {
        setModalOpen(!modalOpen);
    };
    const handleImagenChange = (event, setImagenPreview, setIsImageSelected) => {
        const file = event.target.files[0];

        if (file) {

            const previewURL = URL.createObjectURL(file);
            setImagenPreview(previewURL);
            setIsImageSelected(true);
        }
    };

    const onCheckCategoriaEsServicios = (idCategoria) =>{
        let catSelected = categorias.filter(categoriaFiltrada => categoriaFiltrada.idCategoria == idCategoria);
        if(catSelected[0]){
            const textoNormalizado = (str) => 
              str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

            setCategoriaEsServicio(
              textoNormalizado(catSelected[0].categoria.toLowerCase())
                .includes(textoNormalizado("servicio".toLowerCase()))
            );
        }
    }

    const crear = async () => {
        const form = document.getElementById("crearForm");
        const formData = new FormData(form);
        const resetForm = () => {
            form.reset();
            setImagenPreview1(null);
            setImagenPreview2(null);

            setIsImage1Selected(false);
            setIsImage2Selected(false);
        };
        setMensaje('');

        if (

            !formData.get('titulo') ||
            !formData.get('idCategoria') ||
            !formData.get('masVendido') ||
            !formData.get('precio') ||
            !formData.get('imagen1') ||
            !formData.get('imagen2') ||
            !formData.get('imagen3') ||
            !formData.get('imagen4')
        ) {
            toast.error('Por favor, complete todos los campos correctamente.');
            return;
        }

        // Si usás reglas de temporada alta
        if (rules && Array.isArray(rules)) {
            formData.append("rules_prices", JSON.stringify(rules));
        }        
        formData.append("demora", JSON.stringify(demora));
        formData.append("dias", JSON.stringify(dias));

        setMensaje('Procesando...');

        try {
            const response = await fetch(`${baseURL}/productosPost.php`, {
                method: 'POST',
                body: formData
            });

            const data = await response.json();

            if (data.mensaje) {
                setMensaje('');
                resetForm();
                toast.success(data.mensaje);
                window.location.reload();
            } else if (data.error) {
                setMensaje('');
                toast.error(data.error);
                console.log(data.error);

            }
        } catch (error) {
            console.error('Error:', error);
            setMensaje('');
            toast.error('Error de conexión. Por favor, inténtelo de nuevo.');

        }
    };


    const handleCategoriaChange = (e) => {
        setCategoria(e.target.value);
        onCheckCategoriaEsServicios(e.target.value);
    };
    const handleMasVendidoChange = (e) => {
        setMasVendido(e.target.value);
    };
    const handleStock = (e) => {
        setStock(e.target.value);
    };
    useEffect(() => {
        cargarCategoria();
        cargarProfesionales();
    }, []);

    const cargarProfesionales = () => {
        fetch(`${baseURL}/profesionalesGet.php`)
            .then(res => res.json())
            .then(data => setProfesionales(data.profesionales || []))
            .catch(err => console.error(err));
    };

    const cargarCategoria = () => {
        fetch(`${baseURL}/categoriasGet.php`, {
            method: 'GET',
        })
            .then(response => response.json())
            .then(data => {
                setCategoras(data.categorias || []);
                console.log(data.categorias)
            })
            .catch(error => console.error('Error al cargar contactos:', error));
    };

    const addRule = () => {
        if (!newRuleValue.trim()) return;

        const newRule = {
            type: newRuleType,     // "weekday" o "date"
            value: newRuleValue
        };

        setRules([...rules, newRule]);
        setNewRuleValue("");
    };

    const removeRule = (index) => {
        const updated = rules.filter((_, i) => i !== index);
        setRules(updated);
    };

    const filteredWeekdays = WEEKDAYS.filter(
        d => !rules.some(r => r.type === "weekday" && r.value === d)
    );

    return (
        <div className='NewContain'>
            <ToastContainer />
            {
                productosCantidadAhora < productosCantidadMaxima && (
                    <button onClick={toggleModal} className='btnSave'>
                        <span>  +</span> Agregar
                    </button>
                )
            }
            <p className="quantity-detail-product">{productosCantidadAhora} productos de {productosCantidadMaxima}</p>
            {modalOpen && (
                <div className="modal">
                    <div className="modal-content" style={{"width": "95%","max-width": "inherit"}}>
                        <div className='deFlexBtnsModal'>
                            <button className='selected'>Agregar Producto</button>
                            <span className="close" onClick={toggleModal}>&times;</span>
                        </div>
                        <form id="crearForm">

                            <div className='flexGrap'>
                                <fieldset>
                                    <legend>Título (obligatorio)</legend>
                                    <input
                                        type="text"
                                        id="titulo"
                                        name="titulo"
                                        required
                                        value={titulo}
                                        onChange={(e) => setTitulo(e.target.value)}
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio (obligatorio)</legend>
                                    <input
                                        type="number"
                                        id="precio"
                                        name="precio"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precio}
                                        onChange={(e) => setPrecio(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Categoría (obligatorio)</legend>
                                    <select
                                        id="idCategoria"
                                        name="idCategoria"
                                        value={categoria}
                                        onChange={handleCategoriaChange}
                                    >
                                        <option value="">Selecciona una categoría</option>
                                        {categorias.map(item => (
                                            <option key={item.idCategoria} value={item.idCategoria}>{item.categoria}</option>
                                        ))}
                                    </select>
                                </fieldset>
                                <fieldset>
                                    <legend>Más vendido (obligatorio)</legend>
                                    <select
                                        id="masVendido"
                                        name="masVendido"
                                        value={masVendido}
                                        onChange={handleMasVendidoChange}
                                    >
                                        <option value="">Selecciona opcion</option>
                                        <option value="si">Si</option>
                                        <option value="no">No</option>

                                    </select>
                                </fieldset>
                                
                                    
                                    <input
                                        type="hidden"
                                        id="stock"
                                        name="stock"
                                        min="0"
                                        step="0.01"
                                        required
                                        value="9999"
                                        onChange={(e) => setStock(e.target.value)}
                                    />
                                
                                <fieldset id='descripcion'>
                                    <legend>Descripción</legend>
                                    <textarea
                                        id="descripcion"
                                        name="descripcion"
                                        required
                                        value={descripcion}
                                        onChange={(e) => setDescripcion(e.target.value)}
                                        placeholder="Descripción"
                                    />
                                </fieldset>

                                <fieldset>
                                    <legend>Precio anterior</legend>
                                    <input
                                        type="number"
                                        id="precioAnterior"
                                        name="precioAnterior"
                                        min="0"
                                        step="0.01"
                                        required
                                        value={precioAnterior}
                                        onChange={(e) => setPrecioAnterior(e.target.value)}
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen1</legend>
                                    <input
                                        type="file"
                                        id="imagen1"
                                        name="imagen1"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview1, setIsImage1Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen2</legend>
                                    <input
                                        type="file"
                                        id="imagen2"
                                        name="imagen2"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview2, setIsImage2Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen3</legend>
                                    <input
                                        type="file"
                                        id="imagen3"
                                        name="imagen3"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview3, setIsImage3Selected)}
                                        required
                                    />
                                </fieldset>
                                <fieldset>
                                    <legend>Imagen4</legend>
                                    <input
                                        type="file"
                                        id="imagen4"
                                        name="imagen4"
                                        accept="image/*"
                                        onChange={(e) => handleImagenChange(e, setImagenPreview4, setIsImage4Selected)}
                                        required
                                    />
                                </fieldset>
                            </div>
                            {(isImage1Selected || isImage2Selected || isImage3Selected || isImage4Selected) &&
                              <div className='previevCategori'>
                                  {isImage1Selected && <img src={imagenPreview1} alt="Vista previa 1" />}
                                  {isImage2Selected && <img src={imagenPreview2} alt="Vista previa 2" />}
                                  {isImage3Selected && <img src={imagenPreview3} alt="Vista previa 3" />}
                                  {isImage4Selected && <img src={imagenPreview4} alt="Vista previa 4" />}
                              </div>
                            }
                            
                            {categoriaEsServicio && categoria && (
                              <div className="servicios-config-container">
                                <hr style={{ border: '0.5px solid #444', margin: '20px 0' }} />
                                <h2 style={{ color: 'var(--text-color2)', marginBottom: '20px' }}>
                                  Configuración de Agenda por Profesional
                                </h2>
                                
                                {profesionales
                                  .filter((prof) => {
                                    try {
                                      // Parseamos las categorías del profesional (que vienen como JSON string)
                                      const catsProf = typeof prof.categorias === 'string' 
                                        ? JSON.parse(prof.categorias) 
                                        : prof.categorias;
                                      
                                      // Verificamos si la categoría seleccionada en el producto (categoria)
                                      // está presente en el array del profesional.
                                      return Array.isArray(catsProf) && catsProf.includes(categoria.toString());
                                    } catch (e) {
                                      return false; // Si hay error en el JSON, no lo mostramos
                                    }
                                  })
                                  .map((prof) => (
                                    <div key={prof.id} className="professional-schedule-block">
                                      <h3 className="prof-title">
                                        Profesional: <strong>{prof.nombre}</strong>
                                      </h3>

                                      {/* Tiempo estimado individual */}
                                      <fieldset className="service-time-field">
                                        <legend>Duración del turno (minutos)</legend>
                                        <input
                                          type="number"
                                          min="5"
                                          step="5"
                                          value={demora[prof.id] || ''} 
                                          onChange={(e) => cambiarDemoraProfesional(prof.id, e.target.value)}
                                          placeholder="Ej: 30"
                                        />
                                      </fieldset>

                                      {/* Días y Turnos */}
                                      <fieldset className="service-turns-field">
                                        <legend>Días de atención y horarios</legend>
                                        <div className="days-grid">
                                          {WEEKDAYS.map((dia) => {
                                            const configDia = dias[prof.id] && dias[prof.id][dia];

                                            return (
                                              <div key={dia} className={`day-item-card ${configDia ? "active" : ""}`}>
                                                <label className="day-checkbox-label">
                                                  <input
                                                    type="checkbox"
                                                    checked={!!configDia}
                                                    onChange={() => toggleDia(prof.id, dia)}
                                                  />
                                                  <span>{dia}</span>
                                                </label>

                                                {configDia && (
                                                  <div className="day-config-content">
                                                    <div className="time-inputs-row">
                                                      <div className="time-group">
                                                        <label>Inicio</label>
                                                        <input
                                                          type="time"
                                                          value={configDia.inicio}
                                                          onChange={(e) => cambiarHora(prof.id, dia, "inicio", e.target.value)}
                                                        />
                                                      </div>
                                                      <div className="time-group">
                                                        <label>Fin</label>
                                                        <input
                                                          type="time"
                                                          value={configDia.fin}
                                                          onChange={(e) => cambiarHora(prof.id, dia, "fin", e.target.value)}
                                                        />
                                                      </div>
                                                    </div>

                                                    <div className="slots-container">
                                                      <label className="slots-label">Turnos generados (click para quitar):</label>
                                                      <div className="slots-wrapper">
                                                        {configDia.turnos.map((t, idx) => (
                                                          <button
                                                            key={idx}
                                                            type="button"
                                                            className={`slot-pill ${t.activo ? 'is-active' : 'is-disabled'}`}
                                                            onClick={() => toggleTurnoEspecifico(prof.id, dia, t.hora)}
                                                          >
                                                            {t.hora}
                                                          </button>
                                                        ))}
                                                      </div>
                                                    </div>
                                                  </div>
                                                )}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </fieldset>
                                    </div>
                                  ))}

                                {/* Mensaje amigable si no hay profesionales en esa categoría */}
                                {profesionales.filter(p => {
                                    try {
                                        const c = JSON.parse(p.categorias);
                                        return c.includes(categoria.toString());
                                    } catch { return false; }
                                }).length === 0 && (
                                    <p style={{ color: 'orange', textAlign: 'center' }}>
                                        No hay profesionales asignados a esta categoría.
                                    </p>
                                )}
                              </div>
                            )}


                            {mensaje ? (
                                <button type="button" className='btnLoading' disabled>
                                    {mensaje}
                                </button>
                            ) : (
                                <button type="button" onClick={crear} className='btnPost'>
                                    Agregar
                                </button>
                            )}
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
}